import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { DEAL_HISTORY } from '../../constants/columns';
import { useParams } from 'react-router-dom';

// components
import EmptyData from '../../components/EmptyData/EmptyData';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/buttonIcons/addDeal.svg';
import getDealHistory from '../../api/deals/getDealHistory';

const columns = DEAL_HISTORY;

const DealHistory = () => {
  const { id } = useParams();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns,
      data: history,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    await getDealHistory({ id })
      .then((res) => {
        setHistory(res?.data || []);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    init();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <EmptyData
          title={`ÐÑÑÐ¾ÑÐ¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ (${history.length})`}
          subtitle={'ÐÐ¾ ÑÑÐ¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ Ð¿Ð¾ÐºÐ° Ð½ÐµÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ Ð² ÑÐ¾ÑÑÐ°Ð²Ðµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ, ÑÑÐ»ÑÐ³ Ð¸Ð»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹.'}
          action={null}
          icon={icon}
          table={table}
          data={history}
        />
      )}
    </>
  );
};

export default DealHistory;
